var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-btn-box",class:[
          'tw-btn-w-'+_vm.wSize,
          'tw-btn-h-'+_vm.hSize ]},[(_vm.type == 'default')?_c('span',{staticClass:"btn-bottom-shadow"}):_vm._e(),_vm._v(" "),_c('button',{class:[
          'tw-btn-'+ _vm.type,
          'tw-btn-w-'+_vm.wSize,
          'tw-btn-h-'+_vm.hSize,
          _vm.isShadow ? 'tw-button-shadow' : '',
          _vm.cursorWait ? 'cursorWait':''
      ],attrs:{"type":_vm.nativeType},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdb5946e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tw-button.vue
// module id = null
// module chunks = 